import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  fetchJudgementData as fetchJudgementDataAPI,
  GetJudgementParam,
} from './api';
import { JudgementData, Status } from '../../services/apiTypes';
import { isJudgementData } from '../../_utils/typeGuardUtils';

interface partsSelectionState {
  status: Status;
  judgementData: JudgementData;
}

const initialState: partsSelectionState = {
  status: 'idle',
  judgementData: {} as JudgementData,
};

export const fetchJudgementData = createAsyncThunk(
  'typeData/fetchJudgementData',
  async (params: GetJudgementParam, { rejectWithValue }) => {
    try {
      return await fetchJudgementDataAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const judgementDataSlice = createSlice({
  name: 'judgementData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchJudgementData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchJudgementData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isJudgementData(action.payload)) {
          state.judgementData = action.payload;
        }
      })
      .addCase(fetchJudgementData.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default judgementDataSlice.reducer;
